import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const PinWheelLinkEvents = gql`
  mutation savePinwheelLinkEvent(
    $eventName: String!
    $linkTokenId: String!
    $eventPayload: JSON
  ) {
    pinwheelLinkEvent(
      input: {
        eventName: $eventName
        linkTokenId: $linkTokenId
        eventPayload: $eventPayload
      }
    ) {
      __typename
      ... on PinwheelLinkEventSuccess {
        success
      }
      ... on PinwheelLinkEventError {
        ...error
      }
    }
  }
  ${error}
`;

export default PinWheelLinkEvents;
